import { maxLength100, maxLength20 } from "./validation";
export var regFormDataValid = function (field, generalUserInfo) {
    var value = generalUserInfo[field.name];
    var error = '';
    if (!error) {
        if (field.name === 'website') {
            return '';
        }
        else if (field.name === 'companyName') {
            var maxLengthError = maxLength100(100, 'CustDashboard.form.maxLength100')(value);
            if (maxLengthError) {
                error = maxLengthError;
            }
        }
        else {
            var maxLengthErrorKey = maxLength20(20, 'CustDashboard.form.maxLength20')(value);
            if (maxLengthErrorKey) {
                error = maxLengthErrorKey;
            }
        }
    }
    return error;
};
export var validateEmail = function (value, setEmailError) {
    if (!value || /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,64}$/i.test(value)) {
        setEmailError('');
        return true;
    }
    else {
        setEmailError('CustDashboard.invalidEmailAddress');
        return false;
    }
};
